import React from 'react';

export const isNextBuild =
  process.env.NEXT_PUBLIC_APP_BUILD_TARGET === 'next' ||
  process.env.REACT_APP_BUILD_TARGET === 'next';

let NextLink, NextImage, usePathname, useRouter;


if (isNextBuild) {
  NextLink = require('next/link').default;
  NextImage = require('next/image').default;
  usePathname = require('next/navigation').usePathname;
  useRouter = require('next/navigation').useRouter;

} else {
  const { useLocation, useNavigate } = require('react-router-dom');

  usePathname = () => {
    const location = useLocation();
    return location.pathname; 
  };

  useRouter = () => {
    const navigate = useNavigate();
    return {
      push: navigate,
    };
  };
}

export const Link = ({ href, children, ...props }) => {
  if (isNextBuild && NextLink) {
    return (
      <NextLink href={href} {...props}>
        {children}
      </NextLink>
    );
  } else {
    return (
      <a href={href} {...props}>
        {children}
      </a>
    );
  }
};

export const Image = ({ src, alt, width, height, ...props }) => {
  const imageSrc = typeof src === 'object' && src ? src : src;
  const defaultWidth = width || 20; 
  const defaultHeight = height || 20; 
  const defaultAlt = alt || 'Net88';
  if (isNextBuild) {
    return (
      <NextImage
        src={imageSrc}
        alt={defaultAlt}
        width={defaultWidth}
        height={defaultHeight}
        {...props}
      />
    );
  } else {
    return (
      <img
        src={imageSrc}
        alt={defaultAlt}
        width={defaultWidth}
        height={defaultHeight}
        {...props}
      />
    );
  }
};

export { usePathname, useRouter };